import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./auth/AuthContext.jsx";
import Layout from "./components/Layout.jsx";
import Login from "./pages/Login.jsx";
import SsoCallback from "./pages/SsoCallback.jsx";
import Spend from "./pages/Spend.jsx";
import Summary from "./pages/Summary.jsx";
import Savings from "./pages/Savings.jsx";
import ByAccount from "./pages/ByAccount.jsx";
import ByService from "./pages/ByService.jsx";
import Invoices from "./pages/Invoices.jsx";
import Trend from "./pages/Trend.jsx";
import Accounts from "./pages/Accounts.jsx";

function Protected({ children }) {
  const { session, loading } = useAuth();
  if (loading)
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", color: "var(--ink-muted)", fontSize: 14 }}>
        Loading…
      </div>
    );
  if (!session) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* Google / Microsoft sign-in lands here; must stay outside Protected. */}
      <Route path="/auth/callback" element={<SsoCallback />} />
      <Route
        path="/*"
        element={
          <Protected>
            <Routes>
              {/* Spend is the index route and renders its own header, because
                  the freshness stamp and Refresh button live in the header's
                  right-hand slot. */}
              {/* Summary is the landing page: the plain-language view for
                  management. Spend is the detailed view behind it. */}
              <Route path="/" element={<Navigate to="/summary" replace />} />
              <Route path="/summary" element={<Summary />} />
              <Route path="/spend" element={<Spend />} />

              {/* Its own page rather than a fifth Spend section: a
                  recommendation list is a to-do list you work through, which is
                  a different kind of surface from a page you read. */}
              <Route path="/savings" element={<Savings />} />

              <Route path="/trend" element={<Layout><Trend /></Layout>} />
              <Route path="/invoices" element={<Layout><Invoices /></Layout>} />
              <Route path="/accounts" element={<Layout><Accounts /></Layout>} />

              {/* Folded into the Spend page's Breakdown panes and dropped from
                  the nav, but still routed: By Service carries the tag-filter
                  workflow, which the new design does not yet have a home for.
                  Remove these two once that decision is made. */}
              <Route path="/by-account" element={<Layout><ByAccount /></Layout>} />
              <Route path="/by-service" element={<Layout><ByService /></Layout>} />

              <Route path="*" element={<Navigate to="/summary" replace />} />
            </Routes>
          </Protected>
        }
      />
    </Routes>
  );
}
